import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import DepressionReport from "./component";

import {
  getAssessment,
  getAssessmentAttemptByUserId,
  getInsightfulContent,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";

import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";
import {
  createGuestUser,
  getBilling,
  getGuestUser,
  getTransactionDetail,
  GetUserById,
  isGuestOrPremiumUser,
} from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getUserByIdConnect: GetUserById,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,

      getAssessmentConnect: getAssessment,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      getGuestUserConnect: getGuestUser,
      getTransactionDetailConnect: getTransactionDetail,
      guestUserChangesConnect: createGuestUser,
      getBillingConnect: getBilling,
      isGuestOrPremiumUserConnect: isGuestOrPremiumUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DepressionReport);
